module.exports = __webpack_public_path__ + "static/media/Bryant Medium-01.14c8c791.svg";